import { IToastType,  IToastSize, IToastContrast  } from '../../typings';

type IFileDescription = 'model' | 'video' | 'image' | 'audio' | 'file';

const errorSettings = {
    type: IToastType.error,
    contrast: IToastContrast.high, 
    size: IToastSize.mini, 
    closable: true
}

const successSettings = {
    type: IToastType.success, 
    contrast: IToastContrast.default, 
    size: IToastSize.mini, 
    closable: true
}

const infoSettings = {
    type: IToastType.info, 
    contrast: IToastContrast.default, 
    size: IToastSize.mini,
    closable: true
}

export const ToastsData = {
    GeneralError: {
        ...errorSettings,
        message: "Something went wrong. Try reloading the page.", 
    }, 
    TargetImageAllowanceExceededError: {
        ...errorSettings,
        message: 'You have exceeded the target image limit, please upgrade your plan or remove some target images.',
    },
    AppClipUpdateError: {
        ...errorSettings,
        message: "Unable to update triggers.", 
    },
    PreviewError: {
        ...errorSettings,
        message: "Unable to preview project. Try again later.", 
    }, 
    PreviewNoTrkImgError: {
        ...errorSettings,
        message: "At least one scene is missing a target image. Please add it before previewing.", 
    },
    PreviewNo360ContentError: {
        ...errorSettings,
        message: "At least one scene is missing a 360 background. Please add to be able to preview.",
    },
    PreviewNoTrkImgAnd360ContentError: {
        ...errorSettings,
        message: "A target image and one or more 360 background(s) is missing. Please add to be able to preview.",
    },
    PublishSuccess: {
        ...successSettings,
        message: "Project successfully published!", 
    },
    PublishError: {
        ...errorSettings,
        message: "Unable to publish project. Try again later.", 
    }, 
    PublishNo360ContentError: {
        ...errorSettings,
        message: "At least one scene is missing a 360 background. Please add to be able to publish."
    },
    PublishNoTrkImgAnd360ContentError: {
        ...errorSettings,
        message: "A target image and one or more 360 background(s) is missing. Please add to be able to publish.",
    },
    PublishNoTrkImgError: {
        ...errorSettings,
        message: "At least one scene is missing a target image. Please add it before publishing.", 
    },
    NoAccessGrantedError: {
        ...errorSettings,
        message: "You don't have access to this project. Choose another project from Zapworks.",
        closable: false,
    },
    SessionExpiredError: {
        ...errorSettings,
        message: "Your session has expired. Refresh the page to log back in to Zapworks.",
        closable: false,
    },
    DuplicatingProjectError: {
        ...errorSettings,
        message: "This project is already being duplicated. Please wait for the process to finish.",
        closable: false,
    },
    MismatchedVersionError: {
        ...errorSettings,
        message:'Designer has been updated. Please reload the page for the latest version.',
        closable: false,
    },
    SocketConnectionError: {
        ...errorSettings,
        message:'Unable to connect to server. Try reloading the page.',
        closable: false,
    }, 
    AppClipUpdateSuccess: {
        ...successSettings,
        message: 'Triggers successfully updated.',
    },
    SocketConnectionSuccess: {
        ...successSettings,
        message: 'Connection with server established.',
    },
    SocketReconnecting: {
        ...infoSettings, 
        message: 'Connecting to server.',
    },
    CopyToClipboard: {
        ...infoSettings, 
        message: 'Copied to clipboard.',
    },
    AuthorizationError: {
        ...errorSettings,
        message: 'Authentication failed. Try reloading the app.',
        closable: false,
    },
    InternalServerError: {
        ...errorSettings,
        message: 'Internal server error. Try reloading the app.', 
        closable: false,
    }, 
    FailureLoadingError: {
        ...errorSettings,
        message: 'Failure loading component.',
    },
    MaxUploadSizeExceededError: (filesize: number, fileDesc: IFileDescription) => {
        return {
            ...errorSettings,
            message: `Maximum upload size for ${fileDesc} files exceeded (${filesize}MB) .`,
        }
    },
    ErrorWithCustomMessage: (message: string) => ({
        ...errorSettings,
        message,
    }),
    SuccessWithCustomMessage: (message: string) => ({
        ...successSettings,
        message,
    })
}